import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Button } from '@/components/ui/button-partners'
import { MessageCircle, X, ChevronDown } from 'lucide-react'
import {
  Lightbulb,
  Heart,
  Users,
  UserPlus,
  Wallet,
  Tag,
  TrendingUp,
  Copy,
  Gift,
  BadgeCheck,
  BarChart3,
  LogOut,
  BookOpen,
  Headphones,
} from 'lucide-react'

const faqItems = [
  {
    icon: Lightbulb,
    question: 'O que é o programa?',
    shortAnswer:
      'Parceria para divulgar nossos FotoLivros e receber uma participação por vendas com seu cupom.',
    fullAnswer:
      'O programa é uma parceria para divulgar nossos FotoLivros. Você compartilha nossos produtos com seu público e recebe uma participação por cada venda realizada através dos seus cupons.\n\nMais do que ganhar um dinheiro extra, você oferece experiências reais e memoráveis para sua comunidade.',
  },
  {
    icon: Heart,
    question: 'Qual é a proposta de valor?',
    shortAnswer:
      'Mais do que participação nas vendas — é sobre transformar experiências em memórias tangíveis.',
    fullAnswer:
      'Participar do programa não é apenas sobre participação. É sobre transformar experiências em memórias palpáveis para seus seguidores ou clientes:\n\nSe você é fotógrafo, seus clientes podem criar FotoLivros com suas fotos impressas.\n\nSe você tem uma assessoria de corrida, seus alunos podem eternizar conquistas em FotoLivros de corridas e se manter motivado.\n\nSe você atua em viagens, eventos ou qualquer outro nicho, seu público pode guardar momentos importantes de forma tangível.\n\nA ideia é que o programa agregue valor real para quem você indica, tornando a parceria mais autêntica e relevante.',
  },
  {
    icon: Users,
    question: 'Quem pode participar?',
    shortAnswer:
      'Qualquer pessoa com comunidade ativa e afinidade com histórias e memórias.',
    fullAnswer:
      'Qualquer pessoa com uma comunidade ativa e que queira compartilhar experiências e memórias com seu público. Basta ter afinidade com histórias, momentos especiais e inspirar pessoas.',
  },
  {
    icon: UserPlus,
    question: 'Como me inscrevo?',
    shortAnswer: 'Basta se cadastrar, ser aprovado e vincular sua conta Asaas.',
    fullAnswer:
      'Primeiro, você se cadastra na plataforma. Após análise, sua conta é aprovada e você recebe um email de confirmação. Depois disso você complementa seu cadastro com o número da sua conta Asaas e começa a criar cupons e começar a divulgar.',
  },
  {
    icon: Wallet,
    question: 'Por onde recebo?',
    shortAnswer: 'Pagamentos via Asaas, automáticos e seguros por split.',
    fullAnswer:
      'Todos os pagamentos são feitos exclusivamente pelo Asaas. Para receber suas comissões, você precisa ter uma conta Asaas ativa e vinculá-la à sua conta de Influencer. Os repasses acontecem de forma automática, via split, e segura, no mesmo instante que o cliente efetuar o pagamento, ou que for liberado a parcela do cartão.',
  },
  {
    icon: Tag,
    question: 'Como criar meu cupom?',
    shortAnswer:
      'Crie cupons com desconto, validade e código personalizados no painel.',
    fullAnswer:
      'No painel de Influencer você pode criar cupons personalizados definindo:\n\n• O valor do desconto oferecido aos seguidores\n• A validade do cupom\n• O código que será compartilhado\n\nO restante do limite da sua participação será seu ganho. Por exemplo, se seu limite é 20% e você oferece 10% de desconto, você recebe 10% de participação.',
  },
  {
    icon: TrendingUp,
    question: 'Quanto posso ganhar?',
    shortAnswer: 'Depende das vendas e do percentual que você definir.',
    fullAnswer:
      'O valor que você recebe depende do quanto seu público comprar e do seu % de ganho. O nosso ticket varia, de R$ 450 até R$ 6.000.',
  },
  {
    icon: Copy,
    question: 'Posso criar mais de um cupom?',
    shortAnswer:
      'Sim, você pode criar quantos cupons quiser e adaptá-los ao seu público.',
    fullAnswer:
      'Sim. Você pode criar quantos cupons quiser, adaptando o desconto, validade e nome do código conforme seu público ou produto.',
  },
  {
    icon: Gift,
    question: 'Receberei algum material da FotoLivro?',
    shortAnswer:
      'Sim, você recebe um kit de mídia digital com imagens e textos prontos.',
    fullAnswer:
      'Sim. Você recebe um kit de mídia digital com imagens, textos e sugestões de posts para facilitar a divulgação dos FotoLivros de forma profissional.',
  },
  {
    icon: BadgeCheck,
    question: 'Tem algum custo para participar?',
    shortAnswer: 'Não. O programa é totalmente gratuito.',
    fullAnswer:
      'Não. O programa é totalmente gratuito. Você não paga nada para participar nem para criar seus cupons.',
  },
  {
    icon: BarChart3,
    question: 'Como acompanho minhas vendas?',
    shortAnswer: 'No painel de Influencer você acompanha tudo em tempo real.',
    fullAnswer:
      'No painel de Influencer você acompanha as vendas em tempo real, o desempenho dos cupons e o saldo disponível para recebimento.',
  },
  {
    icon: LogOut,
    question: 'Posso sair do programa quando quiser?',
    shortAnswer: 'Sim. Você pode encerrar sua participação a qualquer momento.',
    fullAnswer:
      'Sim. Você pode encerrar sua participação a qualquer momento. As comissões pendentes serão pagas normalmente pelo Asaas conforme o prazo informado.',
  },
  {
    icon: BookOpen,
    question: 'Como escolher quais FotoLivros divulgar?',
    shortAnswer:
      'Temos modelos para todas as ocasiões e momentos especiais. Você escolhe o que mais combina com seu público de acordo com o evento, o estilo e a história.',
    fullAnswer:
      'Nossas Linhas:\n\nLúmina: O equilíbrio entre leveza e cuidado.\n\nInspiração: O melhor custo-benefício para quem não abre mão de um design profissional.\n\nVirtuose: Folhas robustas e experiência tátil de alta qualidade para histórias que merecem destaque.\n\nMagnifique: O auge da sofisticação com capa em acrílico e lombada em couro.\n\nA escolha do modelo ideal valoriza o seu trabalho e garante que o design profissional exclusivo honre a história de cada cliente.',
  },
  {
    icon: Headphones,
    question: 'Como falo com a equipe?',
    shortAnswer:
      'Atendimento por e-mail ou WhatsApp. Equipe sempre à disposição.',
    fullAnswer:
      'Você pode entrar em contato com o suporte pelo canal disponível no painel ou pelos canais de atendimento da FotoLivro Store. Nossa equipe está à disposição para ajudar em todas as etapas.\n\natendimento@fotolivro.store\nWhatsApp: (41) 99198-5765',
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
}

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const handleCardClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section id="faq" className="w-full py-20 md:py-28 bg-background">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold italic text-foreground">
            FAQ - Perguntas Frequentes
          </h2>
        </motion.div>

        {/* FAQ Cards Grid */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {faqItems.map((item, index) => {
            const Icon = item.icon
            const isOpen = openIndex === index

            return (
              <motion.div
                key={index}
                variants={itemVariants}
                transition={{ duration: 0.4 }}
                onClick={() => handleCardClick(index)}
                className={`
                  relative cursor-pointer rounded-xl p-6 transition-all duration-300 flex flex-col border
                  ${
                    isOpen
                      ? 'bg-primary text-primary-foreground shadow-md border-primary'
                      : 'bg-secondary/10 border-secondary/20 hover:bg-secondary/20'
                  }
                `}
              >
                {/* Close button when open */}
                <AnimatePresence>
                  {isOpen && (
                    <motion.button
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      className="absolute top-3 right-3 w-6 h-6 rounded-full bg-primary-foreground/20 flex items-center justify-center hover:bg-primary-foreground/30 transition-colors"
                      onClick={e => {
                        e.stopPropagation()
                        setOpenIndex(null)
                      }}
                    >
                      <X className="w-4 h-4" />
                    </motion.button>
                  )}
                </AnimatePresence>

                {/* Icon */}
                <div
                  className={`
                  w-12 h-12 rounded-full flex items-center justify-center mb-4 transition-colors
                  ${isOpen ? 'bg-primary-foreground/20' : 'bg-accent/20'}
                `}
                >
                  <Icon
                    className={`w-6 h-6 ${isOpen ? 'text-primary-foreground' : 'text-accent'}`}
                  />
                </div>

                {/* Question */}
                <h3
                  className={`
                  font-sans text-base font-semibold leading-snug mb-2 pr-6
                  ${isOpen ? 'text-primary-foreground' : 'text-foreground'}
                `}
                >
                  {item.question}
                </h3>

                {/* Short Answer (subtitle) */}
                <p
                  className={`
                  font-body text-sm leading-relaxed mb-3
                  ${isOpen ? 'text-primary-foreground/80' : 'text-muted-foreground'}
                `}
                >
                  {item.shortAnswer}
                </p>

                {/* Ver mais - shows when closed */}
                {!isOpen && (
                  <div className="mt-auto pt-2 flex items-center gap-1 text-primary font-sans text-sm font-semibold">
                    <span>Ver mais</span>
                    <ChevronDown className="w-4 h-4" />
                  </div>
                )}

                {/* Full Answer - shows when open */}
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="mt-2 pt-3 border-t border-primary-foreground/20"
                    >
                      <p className="font-body text-sm leading-relaxed text-primary-foreground/90 whitespace-pre-line">
                        {item.fullAnswer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            )
          })}
        </motion.div>

        {/* WhatsApp CTA */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p className="text-muted-foreground mb-4 font-body text-base">
            Ainda tem dúvidas? Fale conosco!
          </p>
          <Button variant="elegant" size="lg" asChild>
            <a
              href="https://wa.me/5541991985765?text=Ol%C3%A1!%20Gostaria%20de%20ser%20influencer%20e%20preciso%20de%20ajuda."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2"
            >
              <MessageCircle className="w-5 h-5" />
              Conversar no WhatsApp
            </a>
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

export default FAQSection
